<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th(width="8%")
          span(:title="$t('ui.category')") {{ $t('ui.category') }}
        th(width="12%")
          span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
        th(width="15%")
          span(:title="$t('ui.provider_name')") {{ $t('ui.provider_name') }}
        th.text-right(width="15%")
          span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
        th.text-right(width="15%")
          span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
        th.text-right(width="15%")
          span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="6").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td
          span(:title="item.category") {{ item.category }}&nbsp;
        td
          span(:title="item.provider_code") {{ item.provider_code }}&nbsp;
        td
          span(:title="item.provider_name") {{ item.provider_name }}&nbsp;
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
      tr.footer
        td.text-right(colspan="3")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
      tr.footer
        td.text-right(colspan="3")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
  }),
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
          this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
          this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalWinLose = totalTbl[0]["winlose"];
          this.grandTotalTurnover = totalTbl[0]["turnover"];
          this.grandTotalValidTurnover = totalTbl[0]["valid_turnover"];
        }
      }
    }
  }
};
</script>
